import gql from 'graphql-tag'

export default gql`

  type Identity {
    id: ID
    email: String
  }

  type AuthenticationResponse {
    user: Identity
    token: String
    refreshToken: String
  }

  type Query {
    token: String
    localUser: Identity
  }
`
